export default __webpack_public_path__ + "static/media/close.96773c83.svg";